import React from 'react';
import type { GetStaticProps, NextPage } from 'next';

import Search from '@/components/pages/Search';
import { getSiteSettings, SiteSettingsType } from '@/api';

import Head from 'next/head';

type Props = {
  siteSettings: SiteSettingsType;
};

const SearchPage: NextPage<Props> = ({ ...rest }) => {
  return (
    <>
      <Head>
        <title>Search</title>
        <meta name="title" content="Search the amica pages and resources" />
        <meta
          name="description"
          content="Find resources about a separation or divorce process, information about parenting plans, and details on how amica works."
        />
      </Head>
      <Search {...rest} />
    </>
  );
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const siteSettings = await getSiteSettings();

  return {
    props: {
      siteSettings,
    },
  };

  return {
    notFound: true,
  };
};

export default SearchPage;
